//#region Dependencias
import React, { Component } from 'react';
import {
    BreadCumb,
    DataTables,
    CreateForecastModal,
    NavBar,
    TimeOut
} from "../../components";
import config from "../../config";
import moment from "moment";
import {
    DISPATCH_ID,
    SERVICE_RESPONSE
} from "../../libs/utils/Const";
import { ApiClient } from "../../libs/apiClient";
import { connect } from "react-redux";
import $ from "jquery";
import { Forecast, ForecastTimeInterval } from '../../components/NewOrder';
const CryptoJS = require("crypto-js");
//#endregion

//#region Variables globales
const apiClient = ApiClient.getInstance();
const dateFormat = (date) => { return moment(date).format("YYYY-MM-DD"); }
const typeView = (view) => {
    switch (view) {
        case "M": return "Mensual";
        case "W": return "Semanal";
        case "D": return "Diario";
        default: return "Mensual";
    }
}

const intervalName = (date, viewType) => {
    const dateParams = date.split('-');
    const dateFormatted = new Date(Number(dateParams[0]), Number(Number(dateParams[1]) - 1), Number(dateParams[2]));

    if (viewType === "M") { return dateFormatted.toLocaleString('es-ES', { month: 'long' }).toUpperCase(); }
    else if (viewType === "W") { return moment(dateFormatted).isoWeek(); }
    else if (viewType === "D") { return moment(dateFormatted).format("DD/MM"); }
}
//#endregion

//#region Componente
class SalesForecastView extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props)
        this.view = "salesForecast";
        this.headersDataTable = [
            { title: "Código", value: true, field: "Code", format: null, classes: "text-left" },
            { title: "Nombre", value: true, field: "Name", format: null, classes: "text-left" },
            { title: "Fecha de inicio", value: true, field: "StartDate", format: dateFormat, classes: "text-center" },
            { title: "Fecha final", value: true, field: "EndDate", format: dateFormat, classes: "text-center" },
            { title: "Visualización", value: true, field: "FormView", format: typeView, classes: "text-left" },
        ];
        this.state = {
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + "currentUser")),
            forecastModel: new Forecast(),
            itemsList: [],
            whsList: [],
            action: 1,
        }
    }

    async componentDidMount() {
        let date = {
            dateInit: moment().startOf("month").format("YYYYMMDD"),
            dateFinal: moment().endOf("month").format("YYYYMMDD"),
        }
        await this.getDocumentsList(date);
        await this.getDataLists();
    }
    //#endregion

    //#region ################# CRUD #################

    //#region Acciones generales
    updateModel = async (forecastModel, updateTimeInterval = false) => {
        if (this.state.action === 2) { forecastModel.hasChanges = true; }

        if (updateTimeInterval) {
            const viewType = forecastModel.View;

            const startDateParams = forecastModel.ForecastStartDate.split('-');
            const endDateParams = forecastModel.ForecastEndDate.split('-');

            const startDate = new Date(startDateParams[0], startDateParams[1] - 1, startDateParams[2]);
            const endDate = new Date(endDateParams[0], endDateParams[1] - 1, endDateParams[2]);

            forecastModel.TimeInterval = this.getTimeInterval(startDate, endDate, viewType);
            for (let i = 0; i < forecastModel.SalesForecastLines.length; i++) {
                let currentLine = forecastModel.SalesForecastLines[i];
                let newTimeInterval = [];

                for (let j = 0; j < forecastModel.TimeInterval.length; j++) {
                    const currentTimeInterval = JSON.parse(JSON.stringify(forecastModel.TimeInterval[j]));
                    const existsTimeInterval = currentLine.TimeInterval.find(({ ForecastedDay }) => currentTimeInterval.ForecastedDay === ForecastedDay);

                    if (!existsTimeInterval) { newTimeInterval.push(currentTimeInterval); }
                    else { newTimeInterval.push(existsTimeInterval); }
                }

                currentLine.TimeInterval = newTimeInterval;
            }
        }
        await this.setState({ forecastModel });
    }

    getDataLists = async () => {
        const { enableSpinner } = this.props;

        enableSpinner(true);

        let itemsList = [];
        let whsList = [];

        const listResponseAPI = await apiClient.getSuggestionCatalogs({ items: true, whs: true });
        if (listResponseAPI.status === SERVICE_RESPONSE.SUCCESS) {
            itemsList = listResponseAPI?.data?.items ?? [];
            whsList = listResponseAPI?.data?.warehouses ?? [];
        }

        await this.setState({ itemsList, whsList });

        enableSpinner(false);
    }

    getTimeInterval = (startDate = new Date(), endDate = new Date(), viewType = "M") => {
        let timeInterval = [];
        let currentDate = new Date(startDate);

        if (viewType === "M") {
            while (currentDate <= endDate) {
                let interval = new ForecastTimeInterval();
                interval.Name = currentDate.toLocaleString('es-ES', { month: 'long' }).toUpperCase();
                interval.ForecastedDay = moment(currentDate).format("YYYY-MM-DD");

                timeInterval.push(interval);
                currentDate.setMonth(currentDate.getMonth() + 1);
            }
        } else if (viewType === "W") {
            while (currentDate <= endDate) {
                let interval = new ForecastTimeInterval();
                interval.Name = moment(currentDate).isoWeek();
                interval.ForecastedDay = moment(currentDate).format("YYYY-MM-DD");

                timeInterval.push(interval);
                currentDate.setDate(currentDate.getDate() + 7);
            }
        } else if (viewType === "D") {
            while (currentDate <= endDate) {
                let interval = new ForecastTimeInterval();
                interval.Name = moment(currentDate).format("DD/MM");
                interval.ForecastedDay = moment(currentDate).format("YYYY-MM-DD");

                timeInterval.push(interval);
                currentDate.setDate(currentDate.getDate() + 1);
            }
        }

        return timeInterval;
    }
    //#endregion

    //#region Crear nuevo documento
    createDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { forecastModel } = this.state;

        try {
            enableSpinner(true);

            let data = {
                table: "OFCT",
                model: forecastModel,
            };

            let responseArray = [];
            let response = await apiClient.createMRPDocument(data);

            try {
                responseArray.push({
                    billing: response.data ? response.data.docNumBilling : '',
                    docNum: response.data ? response.data.DocNum : '',
                    message: response.message ? response.message : '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    billing: '',
                    message: '',
                });
            }

            this.setState({ billingResponseArray: responseArray })

            $("#billingResponseModal").modal("show");
            $("#billingResponseModal").on("hidden.bs.modal", () => { this.setState({ billingResponseArray: null }) });

            if (response.status === 1) { $('#createForecastModal').modal('hide'); }
            enableSpinner(false);
        } catch (e) {
            showAlert({ type: "error", message: JSON.stringify(e) });
            enableSpinner(false);
        }
    }

    createNewDocumentModel = async () => {
        let startDate = new Date();
        startDate.setDate(1);

        let endDate = new Date();
        endDate.setMonth(11);
        endDate.setDate(31);

        let forecastModel = new Forecast();
        forecastModel.ForecastStartDate = moment(startDate).format("YYYY-MM-DD");
        forecastModel.ForecastEndDate = moment(endDate).format("YYYY-MM-DD");

        forecastModel.TimeInterval = this.getTimeInterval(startDate, endDate, "M");
        forecastModel.PrevStartDate = moment(startDate).format("YYYY-MM-DD");
        forecastModel.PrevEndDate = moment(endDate).format("YYYY-MM-DD");

        await this.setState({ forecastModel, action: 1 });
        $("#createForecastModal").modal("show");
    }
    //#endregion

    //#region Consultar Información
    getDocumentsList = async (filters = {}) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        // Filtros de búsqueda de las previsiones
        let data = {
            table: "OFCT",
            filters: {
                dateStart: filters.dateInit || moment().format("YYYY-MM-DD"),
                dateEnd: filters.dateFinal || moment().format("YYYY-MM-DD"),
            }
        };

        enableSpinner(true);
        let docsListResponse = await apiClient.MRPDocumentsList(data);
        enableSpinner(false);

        if (docsListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            docsListResponse = docsListResponse.data || [];
            if (docsListResponse.length === 0) {
                this.setState({ data: [] });
                return showAlert({ type: 'info', message: "No se encontraron resultados correspondientes a la búsqueda.", timeOut: 5000 });
            }

            this.setState({ data: docsListResponse });
        } else {
            this.setState({ data: [] });
            showAlert({ type: 'info', message: `Ocurrio un error al consultar la información. ${docsListResponse}`, timeOut: 5000 });
        }
    };

    openDocumentDetails = async (DocEntry, modalActive = false) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        // Filtros de búsqueda de las previsiones
        let data = {
            table: "OFCT",
            DocEntry
        };

        enableSpinner(true);
        let documentResponse = await apiClient.MRPDocumentDetails(data);
        enableSpinner(false);

        if (documentResponse.status === SERVICE_RESPONSE.SUCCESS) {
            documentResponse = documentResponse.data;

            const forecastLines = [];

            const TimeIntervals = documentResponse.Lines.reduce((acc, line) => {
                const key = `${line.ItemCode}-${line.WhsCode}`;
                if (!acc[key]) {
                    acc[key] = {
                        ItemNo: line.ItemCode,
                        ItemDescription: line.ItemName,
                        Warehouse: line.WhsCode,
                        TimeInterval: []
                    };
                }

                acc[key].TimeInterval.push({
                    Name: intervalName(moment(new Date(line.Date)).format("YYYY-MM-DD"), documentResponse.FormView),
                    ForecastedDay: moment(new Date(line.Date)).format("YYYY-MM-DD"),
                    Quantity: Number(line.Quantity || "0").toFixed(3)
                });

                return acc;
            }, {});

            for (const key in TimeIntervals) { if (Object.prototype.hasOwnProperty.call(TimeIntervals, key)) forecastLines.push(TimeIntervals[key]); }

            let forecastModel = new Forecast();

            forecastModel.AbsID = DocEntry;
            forecastModel.ForecastStartDate = moment(new Date(documentResponse.StartDate)).format("YYYY-MM-DD");
            forecastModel.ForecastEndDate = moment(new Date(documentResponse.EndDate)).format("YYYY-MM-DD");
            forecastModel.ForecastCode = documentResponse.Code;
            forecastModel.ForecastName = documentResponse.Name;
            forecastModel.View = documentResponse.FormView;
            forecastModel.SalesForecastLines = forecastLines;
            forecastModel.TimeInterval = this.getTimeInterval(new Date(documentResponse.StartDate), new Date(documentResponse.EndDate), documentResponse.FormView);

            for (let i = 0; i < forecastModel.SalesForecastLines.length; i++) {
                let currentLine = forecastModel.SalesForecastLines[i];
                let newTimeInterval = [];

                for (let j = 0; j < forecastModel.TimeInterval.length; j++) {
                    const currentTimeInterval = JSON.parse(JSON.stringify(forecastModel.TimeInterval[j]));
                    const existsTimeInterval = currentLine.TimeInterval.find(({ ForecastedDay }) => currentTimeInterval.ForecastedDay === ForecastedDay);

                    if (!existsTimeInterval) { newTimeInterval.push(currentTimeInterval); }
                    else { newTimeInterval.push(existsTimeInterval); }
                }
                currentLine.TimeInterval = newTimeInterval;
            }

            await this.setState({ forecastModel, action: 2 });
            if (!modalActive) $("#createForecastModal").modal("show");

        } else { showAlert({ type: 'error', message: documentResponse.message }); }
    }
    //#endregion

    //#region Actualizar documento
    updateDocument = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { forecastModel } = this.state;

        try {
            enableSpinner(true);

            let data = {
                table: "OFCT",
                model: forecastModel,
            };

            let responseArray = [];
            let response = await apiClient.updateMRPDocument(data);

            try {
                responseArray.push({
                    billing: response.data ? response.data.docNumBilling : '',
                    docNum: response.data ? response.data.DocNum : '',
                    message: response.message ? response.message : '',
                });
            } catch (e) {
                responseArray.push({
                    docNum: '',
                    billing: '',
                    message: '',
                });
            }

            this.setState({ billingResponseArray: responseArray })

            $("#billingResponseModal").modal("show");
            $("#billingResponseModal").on("hidden.bs.modal", () => { this.setState({ billingResponseArray: null }) });

            enableSpinner(false);

            if (response.status === 1) {
                this.openDocumentDetails(forecastModel.AbsID, true);
                return true;
            }
        } catch (e) {
            showAlert({ type: "error", message: JSON.stringify(e) });
            enableSpinner(false);
        }

        return false;
    }
    //#endregion

    //#endregion ########### CRUD - END ##############

    //#region Render
    render() {
        const {
            _user,
            action,
            data,
            itemsList,
            whsList,
            forecastModel,
            billingResponseArray,
        } = this.state;

        const {
            enableSpinner,
            notificationReducer: { showAlert }
        } = this.props;

        const actions = {
            openDocumentDetails: this.openDocumentDetails,
            createDocument: this.createNewDocumentModel,
        }

        let itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        let bytes = CryptoJS.AES.decrypt(itemsDashboard, 'exchange');
        itemsDashboard = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

        let writeAccess = true;
        for (const key in itemsDashboard) { if (Object.hasOwnProperty.call(itemsDashboard, key)) { if (key === this.view) { writeAccess = itemsDashboard[key].Wr } } }

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'PREVISIÓN'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1 text-muted"> &nbsp; PREVISIÓN </h2>
                    <CreateForecastModal
                        action={action}
                        writeAccess={writeAccess}
                        model={forecastModel}
                        updateModel={this.updateModel}
                        createForecast={this.createDocument}
                        updateForecast={this.updateDocument}

                        itemsList={itemsList}
                        whsList={whsList}
                        showAlert={showAlert}
                        enableSpinner={enableSpinner} />
                    <DataTables
                        headers={this.headersDataTable}
                        view={this.view}
                        data={data}
                        search={this.getDocumentsList}
                        actions={actions}
                        billingResponse={billingResponseArray} />
                </div>
            </div>
        );
    }
    //#endregion
}
//#endregion

//#region REDUX
const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};
//#endregion

export default connect(mapStateToProps, mapDispatchToProps)(SalesForecastView); // Exportar componente